/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Outlet } from "react-router-dom";
import styled from "@mui/material/styles/styled";
import { useLocation } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";

import useTheme from "@mui/material/styles/useTheme";
import Navbar from "../components/Navbar";
import SideDrawer from "../components/Navbar/SideDrawer";
import UserAssistancePanel from "../components/UserAssistance/UserAssistancePanel";
import {
  ASSISTANCE_DRAWER_WIDTH_PX,
  UserAssistanceProvider,
  useUserAssistance,
} from "../components/UserAssistance/UserAssistanceContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAppContext } from "../../contexts/useStorageContext";
import { actionTypes } from "../../types/state";

const DrawerWidth = 270;

const Main = styled(Box)(({ theme }) => ({
  height: "100%",
  backgroundColor: theme.palette?.background?.default,
  flexGrow: 1,
}));

function LayoutFrame() {
  const location = useLocation();
  const theme = useTheme();
  const { dispatch, state } = useAppContext();
  const { open: askAnythingOpen } = useUserAssistance();
  const navigation = useNavigate();
  const isLoggedIn = state.loggedInUserInfo?.email;
  const isLargeScreen = useMediaQuery("(min-width:961px)");
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [backendVersions, setBackendVersions] = React.useState({});
  const askDrawerWidth =
    askAnythingOpen && isLoggedIn
      ? isXs
        ? "100%"
        : `${ASSISTANCE_DRAWER_WIDTH_PX}px`
      : "0px";

  React.useEffect(() => {
    if (isLoggedIn) {
      if (location.pathname.length < 2) {
        navigation(`/dashboard`);
      }
    } else {
      navigation(`/`);
    }
  }, []);

  React.useEffect(() => {
    dispatch!({ type: actionTypes.setOpenSideDrawer, value: false });
  }, [isLargeScreen]);

  React.useEffect(() => {
    dispatch!({ type: actionTypes.setOpenSideDrawer, value: false });
  }, [location.pathname]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
      id="app-layout-container"
    >
      {isLoggedIn ? <Navbar /> : null}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "row",
          paddingTop: isLoggedIn ? "56px" : 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flex: askAnythingOpen && isXs ? "0 0 0px" : "1 1 auto",
            width: askAnythingOpen && isXs ? 0 : "auto",
            id: "app-main-scroll",
            minWidth: 0,
            overflow: "auto",
            backgroundColor: "background.default",
          }}
        >
          <Main sx={{ boxSizing: "border-box", p: { xs: 1, sm: 2, lg: 3 } }}>
            <Outlet />
          </Main>
          {isLoggedIn ? (
            <SideDrawer width={DrawerWidth} backendVersions={backendVersions} />
          ) : null}
        </Box>
        {isLoggedIn ? <UserAssistancePanel width={askDrawerWidth} /> : null}
      </Box>
    </Box>
  );
}

export default function Layout() {
  return (
    <UserAssistanceProvider>
      <LayoutFrame />
    </UserAssistanceProvider>
  );
}
